<div class="ui container">
  <div *ngIf="success">
    <h1>Payment Complete</h1>
    <p>
      The bounty reward has been successfully paid!
    </p>
    <a class="ui primary button" [routerLink]="['/bounties', bountyId]">View Bounty</a>
  </div>
  <div *ngIf="!success">
    <h1>Payment Failed</h1>
    <p>Payment has failed or was cancelled by you. If this was unintended, please contact support to help you out.</p>
  </div>
</div>
